import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrganisationInterface } from 'src/app/model/organisations/organisation-interface';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { MarketplaceFilterService } from 'src/app/services/componentServices/marketplace-filter-service/marketplace-filter.service';
import { CheckBoxCategorie } from 'src/app/model/marketplace/marketplace-checkbox';

@Component({
    selector: 'app-product-detail-display-organisation',
    templateUrl: './product-detail-display-organisation.component.html',
    styleUrls: [
        './product-detail-display-organisation.component.css',
        '../product-detail-display.css'
    ],
    standalone: false
})
export class ProductDetailDisplayOrganisationComponent implements OnInit {
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private marketPlaceFilterService: MarketplaceFilterService
    ) {}

    @Input()
    organisation: OrganisationInterface;
    @Output() navigationTriggered = new EventEmitter<void>();

    ngOnInit() {}

    navigateToMarketplace() {
        //this.marketPlaceFilterService.filter.organisationIds.push(this.organisation.organisationId);
        this.marketPlaceFilterService.addFilter(
            this.organisation.organisationId,
            CheckBoxCategorie.ORGANISATION
        );

        if (this.router.url.includes('/products')) {
            this.router.navigate(['/marktplatz'], {
                queryParams: { 
                    tab: 0,
                    orgId: this.organisation.organisationId 
                }
            });
        }
        this.navigationTriggered.emit();
    }

    navigateToOrganisationPage() {
        this.navigationTriggered.emit();
        this.router.navigateByUrl(
            '/marktplatz?tab=2&organisationId=' +
                this.organisation.organisationId
        );
    }
}
